module.exports = __webpack_public_path__ + "static/img/result-vip-in.9718714.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/result-vip-in.png
// module id = 6LoY
// module chunks = 1